import React, { useState, useEffect, useRef } from 'react';
import '../component.scss';
import SearchDropdownVirtualizedList from './SearchDropdownVirtualizedList';
import SearchDropdownMultiselectOpenList from './SearchDropdownMultiselectOpenList';

const SearchWidgetOpen = ({
  value,
  dictionary = {},
  items,
  label,
  title = '',
  width = 220,
  placeholder = true,
  buttonDone = true,
  type = 'base',
  children,
  onChoose,
  isOpen = false,
  hasFilter = false,
  buttonReset = false,
  onReset,
  isHidden = false,
  onHide,
  cssClass = '',
}) => {
  const [collection, setCollection] = useState(items);
  const [wasChanged, setWasChanged] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredOptions, setFilteredOptions] = useState([]);
  const popupRef = useRef(null);

  const setValue = (value) => {
    console.log('value hotels', value);
    onChoose(value);
    setWasChanged(value.length ? true : false);
  };
  // const options = items.map( item => {id: item.id, label: item.name});
  const reset = () => {
    setSearchTerm('');
    setFilteredOptions([]);
    onReset();
    // setFilteredOptions([])
  };
  const toggleHideTouroperator = (e) => {
    const isHide = e.target.checked;
    onHide(isHide);
  };
  const handleInputChange = (event) => {
    const value = event.target.value;
    setSearchTerm(value);

    const filtered = items.filter((option) =>
      option.name.toLowerCase().includes(value.toLowerCase())
    );

    setFilteredOptions(filtered);
  };

  let items_fix = items;
  if (filteredOptions.length) {
    items_fix = filteredOptions;
  }

  return (
    <div
      className={`search-widget-open ${wasChanged} ${cssClass}`}
      style={{ width: width, position: 'relative' }}
    >
      <div
        style={{
          top: '-17px',
          color: '#777',
          textTransform: 'uppercase',
          fontSize: '10px',
          marginLeft: '10px',
        }}
      >
        {label}: {items.length}
      </div>
      <div
        style={{
          position: 'absolute',
          left: '110px',
          top: '0px',
          color: '#3e6a3a',
          textTransform: 'uppercase',
          fontSize: '10px',
          fontWeight: 700,
        }}
      >
        {title}
      </div>
      {isHidden ? (
        <div
          style={{
            top: '-17px',
            color: '#777',
            textTransform: 'uppercase',
            fontSize: '10px',
            marginLeft: '10px',
          }}
        >
          <label>
            <input
              type="checkbox"
              style={{ verticalAlign: 'sub', marginRight: '5px' }}
              onClick={toggleHideTouroperator}
            />
            <span>Скрыть</span>
          </label>
        </div>
      ) : null}
      <div style={{ paddingLeft: '10px' }}>
        {hasFilter && (
          <input
            type="text"
            placeholder={label}
            className="filterinput"
            style={{ width: 300 }}
            value={searchTerm}
            onChange={handleInputChange}
          />
        )}
        {buttonReset && (
          <button className="popup-header-text btn-reset" onClick={reset}>
            Сбросить
          </button>
        )}
      </div>
      <div
        className="search-widget-open__wrap"
        ref={popupRef}
        style={{ width: '100%' }}
      >
        {type == 'multiselect' && (
          <SearchDropdownMultiselectOpenList
            value={value}
            items={items}
            onChoose={setValue}
          />
        )}
        {type == 'virtualized' && (
          <SearchDropdownVirtualizedList
            value={value}
            items={items_fix}
            onChoose={setValue}
          />
        )}
      </div>
    </div>
  );
};

export default SearchWidgetOpen;
